import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Button from './Button'
import SvgIcon from '../icons/SvgIcon'

const ButtonWithIcon = ({
    className = '',
    onClick = f => f,
    disabled = false,
    label = '',
    icon = '',
    children
}) => {
    return (
        <Button
            className={classNames('ButtonWithIcon', className)}
            onClick={(e) => !disabled && onClick(e)}
            disabled={disabled}
        >
            {children ?
                children :
                <>
                    <span className='ButtonWithIcon__icon'>
                        <SvgIcon icon={icon} />
                    </span>
                    <span className='ButtonWithIcon__label'>
                        {label}
                    </span>
                </>
            }
        </Button>
    );
}

ButtonWithIcon.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    label: PropTypes.string,
};

export default ButtonWithIcon;